import template from './template';

const i18n = {
  locale: 'en',
  fallbackLocale: 'en',
  messages: {},
  t(key, ...args) {
    let value = this.messages[this.locale]?.[key] ?? this.messages[this.fallbackLocale]?.[key];

    if (value && args.length > 0) {
      return template(value, ...args);
    }

    return value ?? key;
  },
  replaceHTML() {
    const el = document.querySelector('none-frame');
    if (!el) {
      return;
    }
    let innerHTML = el.innerHTML;
    // 大小写字母、数字、下划线、减号
    const regexp = /{{\s\$t\('([\w-]+)'\)\s}}/g;
    let match;
    const arr = [];
    while ((match = regexp.exec(innerHTML)) !== null) {
      const expressionStr = match[0];
      const key = match[1];
      arr.push([expressionStr, key]);
    }
    for (const [str, key] of arr) {
      innerHTML = innerHTML.replaceAll(str, this.t(key));
    }

    el.outerHTML = innerHTML;
  }
};

export default i18n;
